import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'
import {
    Navbar,
    NavbarDivider,
    NavbarGroup,
    NavbarHeading,
} from '@blueprintjs/core'

import UserMenu from './UserMenu'
import logo from 'src/assets/ckg-logo.svg'
import { LIST_PATH } from 'src/constants/paths'

import styles from './header.module.scss'

class Header extends Component {
    _renderLeftSide() {
        return (
            <NavbarGroup>
                <NavbarHeading className={styles.heading}>
                    <NavLink to="/" className={styles.logoWrapper}>
                        <img id="cgk-logo" alt="Cegeka Logo" src={logo} />
                        <span className={styles.title}>Runbooks</span>
                    </NavLink>
                </NavbarHeading>
                <NavLink
                    className={styles.link}
                    to={LIST_PATH}
                    activeClassName={styles.activeLink}
                >
                    List of Runbooks
                </NavLink>
                <NavbarDivider className={styles.divider} />
                <a
                    href="https://portal.cegeka.com/corporate/qms2/BC-DRP/BC_DRP_Lib/Runbook%20Help/Runbook%20tool%20-%20Help.pptx?web=1"
                    className={styles.link}
                >
                    Need help?
                </a>
            </NavbarGroup>
        )
    }

    _renderRightSide() {
        return (
            <NavbarGroup>
                <UserMenu />
            </NavbarGroup>
        )
    }

    render() {
        return (
            <div className={styles.navbarContainer}>
                <Navbar className={styles.navbar}>
                    {this._renderLeftSide()}
                    {this._renderRightSide()}
                </Navbar>
            </div>
        )
    }
}

export default Header
